<template>
  <Dialog className="dialog-container" :visible="true" @close="closedDialog" :hideClose="true">
    <div class="login-dialog">
      <div class="login-content">
        <header>绑定手机号</header>
        <div class="tip">新用户首次登录即为注册成功</div>
        <section>
          <div>
            <span class="name">手机号</span>
            <div class="value-content">
              <input type="text" v-model="phone" placeholder="请输入手机号">
            </div>
          </div>
          <div>
            <span class="name">验证码</span>
            <div class="value-content">
              <input type="text" class="code-input" v-model="code" placeholder="请输入验证码"> <span class="code" @click="getCode">{{codeText}}</span>
            </div>
          </div>
          <div>
            <button class="bind-button" @click="login">登录</button>
          </div>
          <div class="agree-policy">
            <input class="checkbox" v-model="policyFlag" :checked="policyFlag" type="checkbox" >我已阅读并同意<span class="policy">《用户使用协议》</span>和<span class="policy">《隐私政策》</span>
          </div>
        </section>
      </div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from './svoice-dialog'
import { phoneApplyCode, login, getUserInfo} from 'api/users'
import {isPhone} from 'utils/utils'

export default {
  name: 'super-audio-bag-dialog',
  components: {
    Dialog,
  },
  props: {
    vip: Boolean
  },
  data() {
    return {
      codeText: '发送验证码',
      count: 60,
      phone: '',
      code: '',
      policyFlag: false,
      dialogVisible: true,
    }
  },
  created() {
  },
  methods: {
    closedDialog () {
    },
    checkPolicy () {

    },
    async getCode () {
      if (this.disableCode) {
        this.$toast('60s才可以获取一次验证码哟')
        return
      }
      console.log(this.codeText, this.phone)
      const phoneFlag = isPhone(this.phone)
      if (!phoneFlag) {
        this.$toast('请输入正确的手机号')
        return
      }
      this.disableCode = true
      await phoneApplyCode({
        phone_num: this.phone
      })
      this.codeText= `重新发送${this.count}s`
      this.interval = setInterval(() => {
        if (this.count > 1) {
          this.count--
          this.codeText = `重新发送${this.count}s`
        } else {
          clearInterval(this.interval)
          this.count = 60
          this.codeText = '发送验证码'
          this.disableCode = false
        }
      }, 1000)
    },
    async login () {
      if (!this.policyFlag) {
        this.$toast('同意用户协议和隐私政策后才能登录')
        return
      }
      if (!isPhone(this.phone)) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (!this.code) {
        this.$toast('请输入手机验证码')
        return
      }
      const res = await login({
        phone_num: this.phone,
        code: this.code
      })

      const token = res.data.token
      this.$store.dispatch('global/setToken', token)
      this.getUserInfo(token)
    },
    async getUserInfo(token) {
      const userInfo = await getUserInfo(token)
      this.$store.dispatch('global/setUserInfo', userInfo.data)
      location.reload()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$width: 300px;
.dialog-container ::v-deep .dialog-content {
  border: none;
  border-radius: 6px;
}
.login-dialog {
  width: 850px;
  height: 500px;
  background: url('../assets/images/login.png') no-repeat;
  border-radius: 4px;
  padding-left: 400px;
  box-sizing: border-box;
  color: #555555;
  .login-content {
    width: $width;
    padding-top: 40px;
    margin: 0 auto;
    header {
      font-weight: 500;
      font-size: 26px;
    }
    .tip {
      margin: 5px 0 70px;
      color: #999;
    }
    .name {
      font-size: 16px;
      padding-left: 5px;
    }
    .value-content {
      margin: 10px 0 20px;
      position: relative;
      cursor: pointer;
      input {
        width: $width;
        height: 40px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #EEEEEE;
        padding: 10px 20px;
        box-sizing: border-box;
        cursor: pointer;
        &.code-input {
          padding-right: 130px;
        }
      }
      .code {
        position: absolute;
        right: 0;
        top: 8.5px;
        height: 25px;
        line-height: 25px;
        border-left: 1px solid #EEEEEE;
        width: 120px;
        text-align: center;
        color: #4E6EFF;
      }
    }
    .bind-button {
      width: $width;
      height: 40px;
      background: #4E6EFF;
      border-radius: 4px;
      font-size: 16px;
      color: #fff;
      margin: 10px 0 30px;
    }
    .agree-policy {
      cursor: pointer;
      font-size: 12px;
      display: flex;
      align-items: center;
      input {
        margin-right: 5px;
        border-radius: 2px;
        border: 1px solid #979797;
        cursor: pointer;
      }
      .policy {
        color: #4E6EFF;
        cursor: pointer;
      }
    }
  }
}
 
</style>
